<template>
    <b-sidebar id="add-new-position-sidebar" 
    :visible="isAddNewPositionSidebarActive" 
    bg-variant="white" sidebar-class="sidebar-lg" 
    shadow 
    backdrop 
    no-header 
    right 
    @hidden="resetForm" 
    @change="(val) => $emit('update:is-add-new-position-sidebar-active', val)"
    >
        <template #default="{ hide }">
                  <!-- Header -->
                  <div
                    class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
                  >
                    <h5 class="mb-0">{{button_text}} New Position</h5>
            
                    <feather-icon
                      class="ml-1 cursor-pointer"
                      icon="XIcon"
                      size="16"
                      @click="hide"
                    />
                  </div>
            
                  <!-- Body -->
                  <validation-observer 
                    #default="{ handleSubmit }"
                    ref="refFormObserver"
                  >
                  <b-overlay
                        :show = 'loading'
                        spinner-variant="primary"
                        spinner-type="grow"
                        spinner-small
                        rounded="sm"
                        >
                    <!-- Form -->
                    <b-form
                      class="p-2"
                      @submit.prevent="handleSubmit(onSubmit)"
                      @reset.prevent="resetForm"
                    >
                      <!-- Position -->
                      <validation-provider
                        #default="validationContext"
                        name="Position"
                        rules="required"
                      >
                        <b-form-group label="Position" label-for="position">
                          <b-form-input
                            id="position"
                            v-model="positionData.position"
                            autofocus
                            :state="getValidationState(validationContext)"
                            trim
                            placeholder="Position"
                           />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                         
                        </b-form-group>
                      </validation-provider>
                      <!-- Description -->
                     
                        <b-form-group label="Description" label-for="description">
                          <b-form-textarea
                            id="description"
                            v-model="positionData.description"
                            autofocus
                            
                            trim
                          />
                       
                        </b-form-group>
                      
                    
            
                      <!-- Form Actions -->
                      
                      <div class="d-flex mt-2">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          class="mr-2"
                          type="submit"
                        >
                          {{button_text}}
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          type="button"
                          variant="outline-secondary"
                          @click="hide"
                        >
                          Cancel
                        </b-button>
                      </div>
                      
                    </b-form>
                    </b-overlay>
                  </validation-observer>
</template>
  </b-sidebar>
</template>

<script>
import {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormCheckbox,
    BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch } from "@vue/composition-api";
import { required, alphaNum, email } from "@validations";
import { max } from "@/libs/validations.js"
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
    components: {
        BSidebar,
        BForm,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
        BButton,
        BFormTextarea,
        BFormCheckbox,
        vSelect,
        BOverlay,

        // Form Validation
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: 'isAddNewPositionSidebarActive',
        event: 'update:is-add-new-position-sidebar-active',
    },
    props: {
        isAddNewPositionSidebarActive: {
            type: Boolean,
            required: true,
        },
        id: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            required,
            alphaNum,
            email,
            max,
        }
    },
    setup(props, { emit }) {

        const loading = ref(false)

        const blankPositionData = {
            id: 0,
            position: '',
            description: '',
            is_active: 1,
        }
        const button_text = ref('Add')

        const positionData = ref(JSON.parse(JSON.stringify(blankPositionData)))

        const resetpositionData = () => {
            positionData.value = JSON.parse(JSON.stringify(blankPositionData))
        }

        const toast = useToast()

        watch(() => [props.id, props.isAddNewPositionSidebarActive], () => {
            if (props.id > 0 && props.isAddNewPositionSidebarActive) {
                positionData.value.id = props.data.id
                positionData.value.position = props.data.position
                positionData.value.description = props.data.description
                positionData.value.is_active = 1
                if (positionData.value.id > 0) {
                    button_text.value = 'Edit'
                } else {
                    button_text.value = 'Add'
                }
            } else {
                button_text.value = 'Add'
            }


        })

        const onSubmit = () => {
            loading.value = true
            store.dispatch("setting-position/addPosition", positionData.value)
                .then((response) => {
                    loading.value = false
                    emit("update:is-add-new-position-sidebar-active", false);
                    emit('refetch-data')
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Success',
                            text: response.data.message,
                            icon: 'CheckIcon',
                            variant: 'success'
                        }
                    })
                })
                .catch((error) => {
                    loading.value = false
                    toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Fail',
                            text: error.response.data.message,
                            icon: 'HeartIcon',
                            variant: 'danger'
                        }
                    })
                })
        };

        const {
            refFormObserver,
            getValidationState,
            resetForm,
        } = formValidation(resetpositionData)

        return {
            positionData,
            onSubmit,
            refFormObserver,
            getValidationState,
            resetForm,
            button_text,
            loading,
        };


    }

};
</script>

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
#add-new-position-sidebar {
    .vs__dropdown-menu {
        max-height: 200px !important;
    }
}
</style>